module.exports = __webpack_public_path__ + "img/footer-first.208a9cd6.png";